export interface MapConfig {
  colors?: {
    marker?: string;
    neighborMarkers?: string;
  };
}
